[
  {
    "code": "ER-AN",
    "name": "Anseba"
  },
  {
    "code": "ER-DU",
    "name": "Debub"
  },
  {
    "code": "ER-DK",
    "name": "Debubawi Keyih Bahri"
  },
  {
    "code": "ER-GB",
    "name": "Gash-Barka"
  },
  {
    "code": "ER-MA",
    "name": "Maakel"
  },
  {
    "code": "ER-SK",
    "name": "Semien-Keih-Bahri"
  }
]